/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Icon } from 'semantic-ui-react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase'
// import dude from '../utils/dude'

class NavBar extends Component {

  state = {
    activeItem: 'home'
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    return null
    // const { activeItem } = this.state
    // const { auth } = this.props
    // // dude(this.props)
    //
    // let menu = null
    // !isLoaded(auth)
    // ? menu = <span>Loading...</span>
    // : isEmpty(auth)
    //   ? menu = <Menu secondary></Menu>
    //   : menu = (
    //     <Menu>
    //       <Link className="menu item" to="/"  >
    //         <Icon name='paint brush' color='blue'/>
    //       </Link>
    //       <Link className="menu item" to="/admin/users"  >
    //         Users
    //       </Link>
    //       <Menu.Menu position='right'>
    //         <Menu.Item
    //           name='logout'
    //           active={activeItem === 'logout'}
    //           onClick={this.props.firebase.logout}
    //         />
    //       </Menu.Menu>
    //     </Menu>
    //   )
    //
    //   // force it
    //   menu = <Menu secondary>
    //
    //
    //   </Menu>
    //
    // return menu

  }
}


export default compose(
  firebaseConnect(),
  connect(({ firebase: { auth } }) => ({ auth }))
)(NavBar)



// WEBPACK FOOTER //
// ./src/components/partials/NavBar.js